var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"banner",attrs:{"id":"viewport-banner"}},_vm._l((_vm.filteredBanners),function(banner){return _c('BannerController',{key:banner.name,attrs:{"bannerContent":banner},on:{"click":() => _vm.trackBannerClick(banner)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }